<template>
  <div class="home-warp">
    <div class="video-warp">
      <!-- <div id="videoMask" class="video-warp-mask" @click="playVideo()">
        <img src="@/assets/img/play.png" alt />
      </div> -->
      <video id="video" src="@/assets/video/demo.mp4" width="100%" height="680" ref="videoRef" controls autoplay muted
        loop ></video>
    </div>

    <section class="dec-warp" id="decs">
      <div class="layoutMaxWidth">
        <title>皓范 <span class="dot"></span> 引领食堂智慧时代!</title>
        <article>上海皓范信息科技有限公司是一家集金融支付、AI识别技术、餐饮行业信息化等应用开发的高科技公司，目前在上海、北京设有分公司并在各主要城市设服务中心。我们专注团餐行业，为企业、学校、园区的食堂提供完整的“智慧食堂”解决方案，目前在AI菜品识别、人脸支付和安卓智能支付系统方面处于行业领先位置。产品和系统已经在多个学校、大型企业和园区等机构的食堂得到广泛的应用和认可。</article>
      </div>
    </section>
    <section class="pro-warp layoutMaxWidth" id="pro">
      <title>智慧食堂六大产品</title>
      <ul>
        <li>
          <div>
            <img src="@/assets/img/pro1.png" alt />
          </div>
          <div>
            <h5>AI菜品识别计价机</h5>
            <p>突破技术，AI视觉</p>
            <p>菜品识别自动计价机</p>
            <span @click="goPro('ai')">查看详情</span>
          </div>
        </li>
        <li>
          <div>
            <img src="@/assets/img/pro2.png" alt />
          </div>
          <div>
            <h5>人脸支付机</h5>
            <p>不用带卡、刷脸吃饭</p>
            <p>皓范食堂专业人脸系统</p>
            <span @click="goPro('face')">查看详情</span>
          </div>
        </li>
        <li>
          <div>
            <img src="@/assets/img/pro3.png" alt />
          </div>
          <div>
            <h5>安卓智能收银机</h5>
            <p>刷卡、扫码一体化</p>
            <p>全功能收银和管理利器</p>
            <span @click="goPro('card')">查看详情</span>
          </div>
        </li>
        <li>
          <div>
            <img src="@/assets/img/pro4.png" alt />
          </div>
          <div>
            <h5>微信会员中心</h5>
            <p>线上充值、手机点单，</p>
            <p>各种增值服务</p>
            <span @click="goPro('wechat')">查看详情</span>
          </div>
        </li>
        <li>
          <div>
            <img src="@/assets/img/pro5.png" alt />
          </div>
          <div>
            <h5>智慧食堂管理软件</h5>
            <p>皓范食堂管理软件</p>
            <p>让食堂管理更简单</p>
            <span @click="goPro('admin')">查看详情</span>
          </div>
        </li>
        <li>
          <div>
            <img src="@/assets/img/pro6.png" alt />
          </div>
          <div>
            <h5>ERP管理系统</h5>
            <p>多角色业务管理</p>
            <p>模块灵活组合</p>
            <span @click="goPro('erp')">查看详情</span>
          </div>
        </li>
      </ul>
    </section>
    <section class="pre-warp">
      <div class="layoutMaxWidth">
        <title>智慧食堂实际效果</title>
        <ul class="pre-warp-list">
          <li>
            <span>充值时间节省</span>
            <span>60%</span>
          </li>
          <li>
            <span>收银速度提高</span>
            <span>60%</span>
          </li>
          <li>
            <span>收银员人工节省</span>
            <span>40%</span>
          </li>
          <li>
            <span>对账时间节省</span>
            <span>70%</span>
          </li>
        </ul>
      </div>
    </section>
    
    <section class="app-warp" id="appli">
      <title>应用行业</title>
      <ul class="app-warp-list layoutMaxWidth">
        <li>政企单位</li>
        <li>学校</li>
        <li>医院</li>
        <li>园区商务楼</li>
        <li>美食广场</li>
        <li>团餐公司</li>
      </ul>
    </section>
    <section class="cpany-warp">
      <title>合作企业</title>
      <ul class="cpany-warp-list layoutMaxWidth">
        <li v-for="(item ,index) in images" :key="index">
          <img :src="item.src" alt />
        </li>
      </ul>
    </section>
  </div>
</template>

<script>
export default {
  name: "home",
  data() {
    return {
      images: [
        { src: require("../assets/img/cpany1.png") },
        { src: require("../assets/img/cpany2.png") },
        { src: require("../assets/img/cpany3.png") },
        { src: require("../assets/img/cpany4.png") },
        { src: require("../assets/img/cpany5.png") },
        { src: require("../assets/img/cpany6.png") },
        { src: require("../assets/img/cpany7.png") },
        { src: require("../assets/img/cpany8.png") },
        { src: require("../assets/img/cpany9.png") },
        { src: require("../assets/img/cpany10.png") },
        { src: require("../assets/img/cpany11.png") },
        { src: require("../assets/img/cpany12.png") },
        { src: require("../assets/img/cpany13.png") },
        { src: require("../assets/img/cpany14.png") },
        { src: require("../assets/img/cpany15.png") },
        { src: require("../assets/img/cpany16.png") },
        { src: require("../assets/img/cpany17.png") },
        { src: require("../assets/img/cpany18.png") },
        { src: require("../assets/img/cpany19.png") },
        { src: require("../assets/img/cpany20.png") },
        { src: require("../assets/img/cpany21.png") },
        { src: require("../assets/img/cpany22.png") },
        { src: require("../assets/img/cpany23.png") },
        { src: require("../assets/img/cpany24.png") },
        { src: require("../assets/img/cpany25.png") }
      ],
      test: []
    };
  },
  methods: {
    playVideo() {
      $("#videoMask").hide();
      const video = $("#video");
      video[0].play();
      video.attr("controls", true);
    },
    goPro(name) {
      this.$router.push({ name });
    }
  },
  mounted() {
    // $('#videoMask').height(680)
    //  console.log( this.$route.params.activeIndex)
  }
};
</script>
<style lang="scss" scoped>
@import "@/assets/css/_variable.scss";
.home-warp {
}
.video-warp {
  position: relative;
  height: 680px;
  &-mask {
    position: absolute;
    width: 100%;
    height: 680px;
    top: 0;
    left: 0;
    text-align: center;
    background-color: rgba($color: #000000, $alpha: .6);
    z-index: 99;
    img {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }
}

title {
  color: $primary-color;
  display: block;
  font-size: 21px;
  text-align: center;
  font-weight: 530;
}
title::after,
title::before {
  display: inline-block;
  content: "";
  width: 64px;
  height: 1px;
  background-color: #87d4b3;
  vertical-align: middle;
  margin-right: 16px;
}
title::after {
  margin-right: 0px;
  margin-left: 16px;
}

.dec-warp {
  margin: 0 auto;
  text-align: center;
  padding: 44px 0 34px;
  font-size: 11px;
  background-color: $primary-color;
  title {
    color: white;
    margin-bottom: 24px;
    .dot {
      display: inline-block;
      width: 4px;
      height: 4px;
      border-radius: 50%;
      background-color: white;
      vertical-align: middle;
    }
  }
  title::after,
  title::before {
    background-color: white;
  }
  article {
    color: white;
    line-height: 2em;
    font-weight: 400;
    letter-spacing: 1px;
  }
}
.pre-warp {
  margin-top: 61px;
  width: 100%;
  min-height: 304px;
  background: url("~@/assets/img/bg@2x.png") no-repeat top left;
  background-size: cover;
  title {
    color: white;
    padding-top: 46px;
  }
  title::after,
  title::before {
    background-color: #98948f;
  }
  &-list {
    margin-top: 44px;
    display: flex;
    justify-content: space-between;
    li {
      width: 123px;
      height: 123px;
      border-radius: 50%;
      background-color: $primary-color;
      display: flex;
      flex-direction: column;
      font-size: 13px;
      text-align: center;
      color: white;
      span:first-child {
        padding-top: 35px;
        letter-spacing: 2px;
        opacity: 0.8;
      }
      span:last-child {
        font-size: 34px;
        margin-top: 10px;
      }
    }
  }
}
.pro-warp {
  margin-top: 46px;
  ul {
    margin-top: 28px;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    li {
      width: 49%;
      height: 146px;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      border: 1px solid rgba(215, 215, 215, 1);
      margin-bottom: 1.5%;
      div:first-child {
        flex: 1;
        height: 100%;
        background-color: #f8f8f8;
        text-align: center;
        display: flex;
        align-items: center;
        justify-content: center;
        img {
          max-width: 80%;
          max-height: 80%;
        }
      }
      div:last-child {
        flex: 2;
        position: relative;
        top: 0;
        left: 50%;
        transform: translateX(-50%);
        h5 {
          color: #232323;
          font-size: 15px;
          margin-bottom: 7px;
        }
        p {
          line-height: 1.5em;
          font-size: 11px;
          color: #979797;
          text-align: left;
        }
        p::before {
          content: "";
          display: inline-block;
          width: 4px;
          height: 4px;
          border-radius: 50%;
          background-color: #979797;
          vertical-align: middle;
          margin-right: 6px;
        }
        span {
          margin-top: 12px;
          display: inline-block;
          width: 102px;
          line-height: 28px;
          color: white;
          background-color: $primary-color;
          font-size: 13px;
          text-align: center;
          cursor: pointer;
        }
      }
    }
    li:nth-of-type(3) {
      div > img {
        max-height: 60%;
      }
    }
  }
}
.app-warp {
  // margin-top: 58px;
  width: 100%;
  height: 332px;
  // background: url("~@/assets/img/bg1@2x.png") center no-repeat;
  // background-size: 100% 100%;
  background-color: $primary-color;
  title {
    color: white;
    padding-top: 38px;
  }
  title::after,
  title::before {
    background-color: white;
  }

  &-list {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    margin-top: 44px;
    li {
      background-color: white;
      color: $primary-color;
      font-size: 14px;
      width: 32.5%;
      line-height: 73px;
      margin-top: 10px;
      text-align: center;
    }
  }
}
.cpany-warp {
  margin-top: 50px;
  margin-bottom: 61px;
  &-list {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    margin-top: 38px;

    li {
      width: 9.1%;
      margin-right: 1%;
      margin-bottom: 1%;
      img {
        width: 100%;
        height: 100%;
      }
    }
    li:nth-child(10n) {
      margin-right: 0px;
    }
  }
}
</style>
